/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Realtime_UnavailableInputs */

const fr_help_realtime_unavailable = /** @type {(inputs: Help_Realtime_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si le temps réel est indisponible, ce n'est que rarement imputable à Bus Tracker. L'application ne fait qu'afficher les données transmises par les opérateurs.`)
};

const en_help_realtime_unavailable = /** @type {(inputs: Help_Realtime_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If real-time data is unavailable, Bus Tracker is rarely the cause. The application only displays data sent by operators.`)
};

/**
* | output |
* | --- |
* | "If real-time data is unavailable, Bus Tracker is rarely the cause. The application only displays data sent by operators." |
*
* @param {Help_Realtime_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_realtime_unavailable = /** @type {((inputs?: Help_Realtime_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Realtime_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_realtime_unavailable(inputs)
	return en_help_realtime_unavailable(inputs)
});